/// <reference path="../../BaseNew/GAdmHromadnaOperaceBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class HromadnaOperaceAdmVlastnostTypObjektu extends GContentBase {
        private hromadnaOperaceObj: HromadnaOperaceAdmVlastnostTypObjektuObj & GContent;
        private data: Gordic.AdmIsl.Interface.GAdmVlastnostTypObjektuReadDto[];
        private keys: string[];

        onContentReady() {
            this.hromadnaOperaceObj = $.extend(this as GContent, new HromadnaOperaceAdmVlastnostTypObjektuObj())
            this.hromadnaOperaceObj.createBase({
                title: "jres:33000499", //RC 33000499 : Hromadné vázání vlastností, struktur nebo profilů  pro typy objektů
                data: this.data,
                objectFields: (this.hromadnaOperaceObj.typ_vps != null && this.hromadnaOperaceObj.typ_vps != undefined) ? ['ixs_txt'] : ['typ_vps_txt'],
                serviceCnt: "Gordic.Adm.WebControls.HromadnaOperaceAdmVlastnostTypObjektu",
                keys: this.keys,
                contentId: "hromadnaOperaceAdmVlastnostTypObjektu"
            })
        }
    }

    export class HromadnaOperaceAdmVlastnostTypObjektuObj extends GAdmHromadnaOperaceBase<Gordic.AdmIsl.Interface.GAdmVlastnostTypObjektuReadDto> {
        ico: string;
        typ_vps: number;
        typ_obj: number;
        isPovolenoPoradi: boolean;
        private prirazenoVsem: boolean;

        createForm(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            this.prirazenoVsem = true;
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:33000095").addField("gselectbox", Gordic.Prefabs.Select.ekosico(), {
                    model: "model.ico=value.ico",
                    name: "ico",
                    initialValue: { ico: this.ico },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    disabled: true,
                })
            if (this.typ_vps) {
                    form.addRow("jres:29932138").addField("gselectbox", Gordic.Prefabs.Select.admGincvps(), {
                        model: "model.typ_vps=value.typ_vps;model.typ_vps_txt<=value.typ_vps_txt",
                        name: "typ_vps",
                        initialValue: { typ_vps: this.typ_vps },
                        validators: [new Gordic.Validators.Required({ stopping: true })],
                        flag: "required",
                        disabled: true
                    })
            } else {
                    form.addRow("jres:29929518").addField("gselectbox", Gordic.Prefabs.Select.admGincobj(), {
                        model: "model.typ_obj=value.typ_obj;model.typ_obj_txt<=value.typ_obj_txt",
                        name: "typ_obj",
                        validators: [new Gordic.Validators.Required({ stopping: true })],
                        flag: "required",
                        initialValue: { typ_obj: this.typ_obj },
                        itemWidth: "",
                        disabled: true,
                    })
            }
                form.addRow("jres:33000501").addField("gselectbox", { //RC 33000501 : Režim přiřazení
                    model: "model.typ_prirazeni<=value.typ_prirazeni;model.typ_prirazeni_txt<=value.typ_prirazeni_txt",
                    data: [
                        { typ_prirazeni: 0, typ_prirazeni_txt: "jres:33000502" }, //RC 33000502 : Přiřadit všem
                        { typ_prirazeni: 1, typ_prirazeni_txt: "jres:33000503" }, //RC 33000503 : Pouze konkrétním
                    ],
                    itemTemplate: "{typ_prirazeni_txt}",
                    itemWidth: "",
                    name: "typ_prirazeni",
                    graphicInput: "oninput",
                    list: true,
                    initialValue: { typ_prirazeni: 0, typ_prirazeni_txt: "jres:33000502" },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    change: (ev, ctx) => {
                        if (ctx.value?.typ_prirazeni == 1)
                            this.prirazenoVsem = false;
                        else
                            this.prirazenoVsem = true;
                    }
                }) 
            if (this.typ_vps != null && this.typ_vps != undefined) {
                switch (this.typ_vps) {
                    case 0:
                        form.addRow("jres:33000460").addField("gselectbox", Gordic.Prefabs.Select.ginspro(), {
                            serverFilters: {
                                aktivita: 100,
                                priz_vir: 0
                            },
                            multi: true,
                            model: "model.ixs=value.ixs_pro;model.ixs_txt<=value.nazev",
                            name: "ixs",
                            initialValue: this.options.data.map((value) => ({ ixs_pro: value.ixs })),
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            flag: "required",
                            itemWidth: ""
                        });
                        break;
                    case 10:
                        form.addRow("jres:33000461").addField("gselectbox", Gordic.Prefabs.Select.ginsstv(), {
                            serverFilters: {
                                aktivita: 100,
                                priz_vir: 0
                            },
                            multi: true,
                            model: "model.ixs=value.ixs_stv;model.ixs_txt<=value.nazev",
                            name: "ixs",
                            initialValue: this.options.data.map((value) => ({ ixs_stv: value.ixs })),
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            flag: "required",
                            itemWidth: ""
                        });
                        break;
                    case 20:
                        form.addRow("jres:33000455").addField("gselectbox", Gordic.Prefabs.Select.ginsvla(), {
                            serverFilters: {
                                aktivita: 100
                            },
                            multi: true,
                            model: "model.ixs=value.ixs_vla;model.ixs_txt<=value.nazev",
                            name: "ixs",
                            initialValue: this.options.data.map((value) => ({ ixs_vla: value.ixs })),
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            flag: "required",
                            itemWidth: ""
                        });
                        break;
                }
                form.addRow("jres:29929518").addField("gselectbox", Gordic.Prefabs.Select.admGincobj(), {
                    multi: true,
                    model: "model.typ_obj=value.typ_obj;model.typ_obj_txt<=value.typ_obj_txt",
                    name: "typ_obj",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    itemWidth: ""
                })
            } else {
                form.addRow("jres:33000455").addField("gselectbox", Gordic.Prefabs.Select.ginsvla(), {
                    serverFilters: {
                        aktivita: 100,
                    },
                    multi: true,
                    model: "model.ixs_vla=value.ixs_vla;model.ixs_vla_txt<=value.nazev",
                    name: "ixs",
                    initialValue: this.options.data.map((value) => ({ ixs_vla: value.ixs })),
                    itemWidth: ""
                }).addRow("jres:33000461").addField("gselectbox", Gordic.Prefabs.Select.ginsstv(), {
                    serverFilters: {
                        aktivita: 100,
                        priz_vir: 0
                    },
                    multi: true,
                    model: "model.ixs_stv=value.ixs_stv;model.ixs_stv_txt<=value.nazev",
                    name: "ixs",
                    itemWidth: ""
                }).addRow("jres:33000460").addField("gselectbox", Gordic.Prefabs.Select.ginspro(), {
                    serverFilters: {
                        aktivita: 100,
                        priz_vir: 0
                    },
                    multi: true,
                    model: "model.ixs_pro=value.ixs_pro;model.ixs_pro_txt<=value.nazev",
                    name: "ixs_pro",
                    itemWidth: ""
                })
            }
            form.addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                name: "aktivita",
                model: "model.aktivita=value.aktivita;model.aktivita_txt<=value.aktivita_txt",
                initialValue: { aktivita: 100 },
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
            })
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
        }

        createDefineGridData(formData: any): any {
            var resultArray: any = [];
            var poradi = 0;
            if (this.typ_vps != null && this.typ_vps != undefined) {
                var cartesianResult = this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["ixs", "ixs_txt"]), this.transformDataToArrayObject(formData, ["typ_obj", "typ_obj_txt"]));
                cartesianResult.forEach((item) => {
                    poradi = resultArray.filter(obj => obj.typ_obj == item[1]['typ_obj']).length + 1;
                    var data = {
                        ixs: item[0]["ixs"],
                        ixs_txt: item[0]["ixs_txt"],
                        typ_obj: item[1]["typ_obj"],
                        typ_obj_txt: item[1]["typ_obj_txt"],
                        ico: formData['ico'],
                        typ_prirazeni: formData['typ_prirazeni'],
                        typ_prirazeni_txt: formData['typ_prirazeni_txt'],
                        typ_vps: formData['typ_vps'],
                        typ_vps_txt: formData['typ_vps_txt'],
                        aktivita: formData['aktivita']
                    }
                    if (this.isPovolenoPoradi == true && this.prirazenoVsem == true)
                        data["poradi"] = poradi;
                    resultArray.push(data);
                })
            } else {
                var cartesianResult: any[] = [];
                this.addCartesianResult("ixs_vla", 20, this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["ixs_vla", "ixs_vla_txt"]), [{ typ_obj: formData["typ_obj"], typ_obj_txt: formData["typ_obj_txt"] }]), cartesianResult);
                this.addCartesianResult("ixs_pro", 0, this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["ixs_pro", "ixs_pro_txt"]), [{ typ_obj: formData["typ_obj"], typ_obj_txt: formData["typ_obj_txt"] }]), cartesianResult)
                this.addCartesianResult("ixs_stv", 10, this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["ixs_stv", "ixs_stv_txt"]), [{ typ_obj: formData["typ_obj"], typ_obj_txt: formData["typ_obj_txt"] }]), cartesianResult)
                cartesianResult.forEach((item) => {
                    poradi = resultArray.filter(obj => obj.typ_obj == item['typ_obj']).length + 1;
                    var data = {
                        ixs: item["ixs"],
                        ixs_txt: item["ixs_txt"],
                        typ_obj: item["typ_obj"],
                        typ_obj_txt: item["typ_obj_txt"],
                        ico: formData["ico"],
                        typ_prirazeni: formData["typ_prirazeni"],
                        typ_prirazeni_txt: formData['typ_prirazeni_txt'],
                        typ_vps: item['typ_vps'],
                        typ_vps_txt: item['typ_vps_txt'],
                        aktivita: formData["aktivita"]
                    }
                    if (this.isPovolenoPoradi == true && this.prirazenoVsem == true)
                        data["poradi"] = poradi;
                    resultArray.push(data);
                })
            }
            return resultArray;
        }

        private addCartesianResult(itemName: string, typ_vps: number, dataCartesian: any[], cartesianResult: any[]) {
            var typVpsTxt = "";
            switch (typ_vps) {
                case 0:
                    typVpsTxt = "jres:29802650";
                    break;
                case 10:
                    typVpsTxt = "jres:29926624";
                    break;
                case 20:
                    typVpsTxt = "jres:29932128";
                    break;
            }
            dataCartesian.forEach((item) => {
                var data = {
                    ixs: item[0][itemName],
                    ixs_txt: item[0]["{0}_txt".format(itemName)],
                    typ_obj: item[1]["typ_obj"],
                    typ_obj_txt: item[1]["typ_obj_txt"],
                    typ_vps: typ_vps,
                    typ_vps_txt: typVpsTxt
                }
                cartesianResult.push(data);
            })
        }

        createGridFormat(gridFormat: Gordic.Data.GridFormat): Gordic.Data.GridFormat {
            this.createAktivitaColumn(gridFormat);
            gridFormat.addTextColumn({
                caption: "jres:33000501",
                name: "typ_prirazeni_txt",
            }).addTextColumn({
                caption: "jres:29932138",
                name: "typ_vps_txt",
            }).addTextColumn({
                caption: "jres:33000428",
                name: "ixs_txt",
            }).addTextColumn({
                caption: "jres:29929518",
                name: "typ_obj_txt",
            })
            if (this.isPovolenoPoradi == true && this.prirazenoVsem == true) {
                gridFormat.addNumberColumn({
                    caption: "jres:30029253",
                    name: "poradi",
                    editor: {
                        widget: "gnumberbox",
                        options: {
                            validators: [
                                new Gordic.Validators.Required({ stopping: true }),
                                new Gordic.Validators.Range({ min: 1, max: 32767, stopping: true })
                            ]
                        }
                    }
                })
            }
            gridFormat.addTextColumn({
                caption: "jres:33000308",
                name: "ico",
            })
            return gridFormat;
        }

        // Volání zatím přes CSharp (přes ISL zatím nevím jak na hromadné operace)
        saveData(data: any[]): JQueryPromise<any> {
            var saveData: Gordic.AdmIsl.Interface.GAdmVlastnostTypObjektuSaveDto[] = [];
            data.forEach((item) => {
                var itemSave = {
                    typ_obj: item['typ_obj'],
                    ixs: item['ixs'],
                    ico: item['ico'],
                    typ_vps: item['typ_vps'],
                    aktivita: item['aktivita'],
                    NewRecord: true
                }
                if (this.isPovolenoPoradi == true && this.prirazenoVsem == true) {
                    itemSave['poradi'] = item['poradi'];
                }
                saveData.push(itemSave);
            })
            if (data.findIndex(obj => obj["typ_prirazeni"] == 1) == -1) {
                return this.getServiceCnt().call("SaveHromadne", { saveData: saveData }).done((results) => {
                    this.createResultData(results)
                })
            } else {
                return this.getServiceCnt().call("SaveHromadneTypSubjektu", { saveData: saveData }).done((results) => {
                    this.createResultData(results)
                })
            }
        }

        validateRows(data: any): Gordic.Validators.GridError[] {
            return [];
        }

        testExistMethod(data: any[]): JQueryPromise<any> {
            return $.Deferred()
        }
    }
}